import { AxiosError } from "axios";
import { GET_RESET_LINK_VALIDITY } from "../../constants/apiUrls"
import { GET_RESET_LINK_VALIDITY_QUERY_KEY } from "../../constants/queryKeys";
import axiosClient from "../axiosClient";
import { useCustomQuery } from "../utils/useCustomQuery";
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  linkId: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetResetLinkValidity = ({ linkId, onSuccess, onError }: Input) => {
  const getResetLinkValidity = async () => {
    const res = await axiosClient.get<void>(GET_RESET_LINK_VALIDITY, {
      params: {
        id: linkId,
      },
    });

    return res.data;
  };

  return useCustomQuery(
    [GET_RESET_LINK_VALIDITY_QUERY_KEY, linkId],
    getResetLinkValidity,
    {
      onSuccess,
      onError,
      enabled: !!linkId,
    },
    false
  );
};
